import { type } from 'os';
import { Img } from './img';
import { Publication } from './publication';

export class Ecole extends Publication {

    
    nom;
    promoteur;
    autorisation_creation;
    autorisation_ouverture;
    pays;
    adresse;
    bp;
    tel;
    fax;
    email;
    website;
    video_link;
    type;
    particularities;
    partenaires;
    secteur;
    admissions;
    abreviation;
    facultes;
    whatsapp;
    facebook;
    linkedln;
    twitter;
    images: Img[];
    mapscode;
    is_top;
    // images;

    constructor() {
        super();
        //this.formations = [];
        // this.partenaires = '';
        // this.particularities = [];
        this.admissions = [];
        this.facultes = [];
        this.is_top = false;
    }

    
    
   
  }